import type {
  BillingSnapshot,
  BridgeMethod,
  RequestPurchaseParams,
  RequestScopesParams,
  ResizeParams,
  SearchUsersParams,
  TrackEventParams,
} from '@kherel/app-bridge';

const FREE_BILLING: BillingSnapshot = {
  hasAccess: false,
  hasLifetime: false,
  hasSubscription: false,
  lifetimePurchasedAt: null,
  subscriptionPeriodEnd: null,
};

export function createMockResult(
  method: BridgeMethod,
  params: unknown,
): unknown {
  switch (method) {
    case 'TribeAppInit':
      return {
        tribeAppId: 'sdk-lab',
        tribeUserId: 'mock-user-001',
        tribeHostVersion: 'mock-0.8',
        tribePlatform: 'web',
        isAnonymous: false,
      };

    case 'TribeAppGetLaunchParams':
      return {
        params: {
          tribe_app_id: 'sdk-lab',
          tribe_user_id: 'mock-user-001',
          tribe_user_name: 'Ada Lovelace',
          tribe_user_first_name: 'Ada',
          tribe_user_last_name: 'Lovelace',
          tribe_user_username: 'ada',
          tribe_user_avatar_url: '',
          tribe_language: 'en',
          tribe_locale: 'en-US',
          tribe_platform: 'web',
          tribe_host_origin: window.location.origin,
          tribe_ts: String(Math.floor(Date.now() / 1000)),
          tribe_app_settings: '{}',
          tribe_user_rft_badge: 'PIONEER',
          tribe_user_is_anonymous: 'false',
          sign: 'mock-signature',
        },
        publicData: { source: 'standalone-lab' },
        rawQuery: 'tribe_app_id=sdk-lab&sign=mock-signature',
      };

    case 'TribeAppGetUserInfo':
      return {
        id: 'mock-user-001',
        name: 'Ada Lovelace',
        firstName: 'Ada',
        lastName: 'Lovelace',
        username: 'ada',
        avatarUrl: '',
        language: 'en',
        locale: 'en-US',
        subscriptionExpiresAt: null,
        isAnonymous: false,
        rftBadge: 'PIONEER',
      };

    case 'TribeAppSearchUsers': {
      const search = params as SearchUsersParams;
      const query = search.query?.trim() || 'user';
      return {
        users: [
          {
            id: 'mock-user-002',
            name: `${query} Example`,
            username: query.toLowerCase().replaceAll(/\s+/g, '-'),
            avatarUrl: '',
          },
        ],
        total: 1,
      };
    }

    case 'TribeAppCallBackend':
      return {
        status: 200,
        data: {
          mode: 'mock',
          message: 'The host backend proxy accepted this test request.',
        },
      };

    case 'TribeAppRequestScopes': {
      const request = params as RequestScopesParams;
      return {
        accepted: true,
        granted: request.scopes,
      };
    }

    case 'TribeAppShowConfirm':
      return { confirmed: true };

    case 'TribeAppResize': {
      const resize = params as ResizeParams;
      return { actualHeight: resize.height };
    }

    case 'TribeAppGetBilling':
      return FREE_BILLING;

    case 'TribeAppRequestPurchase': {
      const purchase = params as RequestPurchaseParams;
      return {
        succeeded: false,
        billing: FREE_BILLING,
        mockKind: purchase.kind,
      };
    }

    case 'TribeAppTrackEvent': {
      const event = params as TrackEventParams;
      return { accepted: Boolean(event.name) };
    }

    case 'TribeAppClose':
    case 'TribeAppOpenProfile':
    case 'TribeAppOpenDirectMessage':
    case 'TribeAppOpenLink':
    case 'TribeAppShowAlert':
      return undefined;
  }
}
